import { render, staticRenderFns } from "./departmentListing.vue?vue&type=template&id=78a595fb&"
import script from "./departmentListing.vue?vue&type=script&lang=js&"
export * from "./departmentListing.vue?vue&type=script&lang=js&"
import style0 from "./departmentListing.vue?vue&type=style&index=0&id=78a595fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports